import { pullTypeMap, forcePull, getLaunchAppCommonParams, pullEventTypeMap, setLaunchAppEnv } from './utils';
import { getBranch } from '../initSDK';
import { getURL } from '../query';
import { getLaunchAppConfig } from '../webx';
import showLaunchAppUi from './ui/launch-app-ui';
import showPassphraseView from './ui/passphrase-ui';
import showGuideView from './ui/user-guide-ui';
// 拉端方法
// eslint-disable-next-line no-async-promise-executor
export const launchApp = (launchAppConfig = {}) => new Promise(async (resolve, reject) => {
    const { launchAppDchn, phone, env, invokePriority, invokeMode, keyboardToken } = launchAppConfig;
    setLaunchAppEnv(env);
    const params = {
        args: {
            biz: getBranch(),
            url: getURL(),
            pull_event_type: pullEventTypeMap.BTN_CLICK,
            dchn: launchAppDchn,
            phone,
            invoke_mode: invokeMode || 'click',
            invoke_priority: invokePriority,
            uid_web: window.localStorage.getItem('uid_web') || '',
            keyboard_token: keyboardToken
        },
        ...getLaunchAppCommonParams()
    };
    let res = { conf: undefined };
    try {
        res = await getLaunchAppConfig(params, env || 'online');
    }
    catch (e) {
        reject(e);
    }
    // 如果拉端策略返回的是falsy，那么拿初始化时拿到的拉端策略用来兜底
    const launchAppRes = res.conf || {};
    const { pullType, mainDeepLinks, browser } = launchAppRes;
    switch (pullType) {
        // 拉起类型为无动作，表示页面自定义手动拉端，此时不作任何操作
        case pullTypeMap.NO_ACTION:
            resolve(launchAppRes);
            return;
        // 阻断强制拉起，发起拉端动作后，展示等待拉端结果半弹窗
        case pullTypeMap.FORCE_PULL: {
            const mainDeepLink = mainDeepLinks[0];
            const { linkType, link } = mainDeepLink;
            // 该部分逻辑是为了做AB实验而临时添加的，后面去掉，linkType为6代表拉端口令
            if (linkType === 6) {
                showPassphraseView(link);
                resolve(launchAppRes);
            }
            else {
                showLaunchAppUi(launchAppRes, phone, keyboardToken)
                    .then(() => resolve(launchAppRes))
                    .catch(() => reject(launchAppRes));
                forcePull(mainDeepLink, browser);
            }
            break;
        }
        // 引导拉起，让用户点击手机右上角菜单项，选择在浏览器内打开页面
        case pullTypeMap.GUIDE_PULL: {
            showGuideView();
            resolve(launchAppRes);
            break;
        }
        case pullTypeMap.PASSPHRASE: {
            const link = mainDeepLinks[0].link;
            showPassphraseView(link);
            resolve(launchAppRes);
            break;
        }
        default:
            reject(launchAppRes);
    }
});
